import React from 'react';
import { baseXUnit, breakpoints, zIndex } from '../../../styles/theme';

const StickyBottomBox: React.FunctionComponent = ({ children }) => {
  return (
    <div className="sticky-bottom-box">
      {children}
      {/*language=CSS*/}
      <style jsx>{`
        .sticky-bottom-box {
          position: fixed;
          bottom: 0;
          left: 0;
          width: 100%;
          z-index: ${zIndex.stickyBottomBox};
        }

        @media ${breakpoints.large} {
          .sticky-bottom-box {
            left: auto;
            right: ${baseXUnit(5)};
            width: ${baseXUnit(90)};
          }
        }
      `}</style>
    </div>
  );
};

export default StickyBottomBox;
